/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarGroup } from '../../models/calendar-group';
import { CalendarGroupUpdate } from '../../models/calendar-group-update';

export interface UpdateCalendarGroup$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: CalendarGroupUpdate
}

export function updateCalendarGroup(http: HttpClient, rootUrl: string, params: UpdateCalendarGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarGroup>> {
  const rb = new RequestBuilder(rootUrl, updateCalendarGroup.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendarGroup>;
    })
  );
}

updateCalendarGroup.PATH = '/api/v1/calendars/groups/{id}';
